function normalizeAiccTaskId(value: unknown): string | undefined {
    if (Array.isArray(value)) {
        return normalizeAiccTaskId(value[0]);
    }

    if (typeof value === 'string') {
        return value || undefined;
    }

    if (typeof value === 'number') {
        return String(value);
    }

    return undefined;
}

function getAiccTaskIdFromQuery(query: unknown): string | undefined {
    if (!query || typeof query !== 'object') return undefined;

    const record = query as Record<string, unknown>;
    return normalizeAiccTaskId(record.taskId);
}

function getAiccTaskIdFromCurrentUrl(href = window.location.href): string | undefined {
    try {
        const url = new URL(href);
        const searchTaskId = normalizeAiccTaskId(url.searchParams.get('taskId'));
        if (searchTaskId) return searchTaskId;

        const hash = url.hash.startsWith('#') ? url.hash.slice(1) : url.hash;
        const queryIndex = hash.indexOf('?');
        if (queryIndex < 0) return undefined;

        return normalizeAiccTaskId(new URLSearchParams(hash.slice(queryIndex + 1)).get('taskId'));
    } catch {
        return undefined;
    }
}

function buildAiccEventDetail(pageUrl: string, params: Record<string, unknown> = {}) {
    return JSON.stringify({
        agent: 'aicc',
        pageUrl,
        params,
    });
}

export {
    buildAiccEventDetail,
    getAiccTaskIdFromCurrentUrl,
    getAiccTaskIdFromQuery,
};
